import React from 'react';
import { connect } from 'react-redux';

import {
  AvailabilityCheckMetaType,
  CmsPageContentIdentifier,
  CmsPageContentType,
  Feature,
  ReduxStateType,
  TariffOfferType,
} from '@/types/av-check';
import { interpolate } from '@/utils';
import Item from './Item';

export interface StateProps {
  cmsContent: CmsPageContentType,
  enabledFeatures : Feature[],
  meta: AvailabilityCheckMetaType,
}

export interface OfferRowsProps {
  offer: TariffOfferType,
  alternativeOffer?: TariffOfferType,
  alternativeOfferHint: CmsPageContentIdentifier,
  dispatchEvent: Function,
  technologyPricingLabels: { DISCOUNT:string, SURCHARGE: string, MONTHLYLIST: string },
  setShowDTAGSpecificationView: (showDTAGSpecificationView:boolean) => void,
  setSelectedOfferName: (selectedOfferNAme:string) => void,
  dtagSpecificAvChecked: boolean,
  setDtagSpecificAvChecked: (dtagSpecificAvCheck:boolean) => void,
  setShowPdpActivationCostInfo?: (showPdpActivationCostInfo:boolean)=>void,
  setShowPdpDevelopmentCostInfo?: (showPdpDevelopmentCostInfo:boolean)=>void,
  originalOffer: TariffOfferType,
  originalOfferName:string,
}

const OfferRows = ({
  offer,
  alternativeOffer,
  cmsContent,
  alternativeOfferHint,
  dispatchEvent,
  technologyPricingLabels,
  setShowDTAGSpecificationView,
  setSelectedOfferName,
  dtagSpecificAvChecked,
  setDtagSpecificAvChecked,
  setShowPdpActivationCostInfo,
  setShowPdpDevelopmentCostInfo,
  enabledFeatures,
  meta,
  originalOffer,
  originalOfferName,

}: StateProps & OfferRowsProps) => (
  <>
    {offer && (
      <Item
        tariffOffer={offer}
        buttonText={cmsContent[CmsPageContentIdentifier.ContinueWithSelectedTariffButton]}
        dispatchEvent={(offer.offerName == originalOfferName) ? dispatchEvent : undefined}
        technologyPricingLabels={technologyPricingLabels}
        cms={cmsContent}
        setShowDTAGSpecificationView={setShowDTAGSpecificationView}
        setSelectedOfferName={setSelectedOfferName}
        dtagSpecificAvChecked={dtagSpecificAvChecked}
        setDtagSpecificAvChecked={setDtagSpecificAvChecked}
        setShowPdpActivationCostInfo={setShowPdpActivationCostInfo}
        setShowPdpDevelopmentCostInfo={setShowPdpDevelopmentCostInfo}
        isDtagToggleShopEnabled = {(!meta.cciTheme && enabledFeatures.includes(Feature.DTAG_FTTH_WEBSHOP))}
        isDtagToggleCciEnabled = {(meta.cciTheme && enabledFeatures.includes(Feature.DTAG_FTTH_CCI))}
        isDtagGuiEnhancementEnabled = {(!meta.cciTheme && enabledFeatures.includes(Feature.DTAG_GUI_ENHANCEMENTS))}
        isDtagGuiEnhancementCCIEnabled = {(meta.cciTheme && enabledFeatures.includes(Feature.DTAG_GUI_ENHANCEMENTS_CCI))}
        originalOffer={originalOffer}
        originalTariffOfferName={originalOfferName}
      />
    )}

    {alternativeOffer && (
      <Item
        tariffOffer={alternativeOffer}
        originalOfferName={originalOfferName}
        offerHint={cmsContent[alternativeOfferHint]}
        buttonText={interpolate(
          cmsContent[CmsPageContentIdentifier.ContinueWithOtherTariffButton],
          { name: alternativeOffer.cmsTariffDescription.name.rendered },
        )}
        technologyPricingLabels={technologyPricingLabels}
        cms={cmsContent}
        setShowDTAGSpecificationView={setShowDTAGSpecificationView}
        setSelectedOfferName={setSelectedOfferName}
        dtagSpecificAvChecked={dtagSpecificAvChecked}
        setDtagSpecificAvChecked={setDtagSpecificAvChecked}
        setShowPdpActivationCostInfo={setShowPdpActivationCostInfo}
        setShowPdpDevelopmentCostInfo={setShowPdpDevelopmentCostInfo}
        isDtagToggleShopEnabled = {(!meta.cciTheme && enabledFeatures.includes(Feature.DTAG_FTTH_WEBSHOP))}
        isDtagToggleCciEnabled = {(meta.cciTheme && enabledFeatures.includes(Feature.DTAG_FTTH_CCI))}
        isDtagGuiEnhancementEnabled = {(!meta.cciTheme && enabledFeatures.includes(Feature.DTAG_GUI_ENHANCEMENTS))}
        isDtagGuiEnhancementCCIEnabled = {(meta.cciTheme && enabledFeatures.includes(Feature.DTAG_GUI_ENHANCEMENTS_CCI))}
        originalOffer={originalOffer}
        originalTariffOfferName={originalOfferName}
      />
    )}
  </>
);

const mapStateToProps = (state: ReduxStateType) => ({
  cmsContent: state.cmsContent,
  enabledFeatures: state.enabledFeatures,
  meta: state.meta,
});

export default connect(mapStateToProps)(OfferRows);
